import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import { Col, Form, Row, Tab, Tabs, Table } from "react-bootstrap";
import toast from "react-hot-toast";
import Select from "react-select";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Delete from "../../../Components/Modals/DeleteModal";
import Navbar from "../../../Components/Navbar/Navbar";
import TableTemp from "../../../Components/TableTemplate/Table";
import AdjustmentTable from "./../../Inventory/Adjustment/AdjustmentTable";
import {
    dateFormat,
    formatDateNoTime,
    formatDate,
    numberFormat,
    refreshPage,
    toastStyle,
    getTodayDate,
    getType,
    TokenExpiry
} from "../../../Helpers/Utils/Common";
import DatePicker from "react-datepicker";
import Moment from "moment";
import cleanLogo from "../../../Assets/Images/Login/transparent_bg.png";
import signature from "../../../Assets/Images/signature.png";

import { getAllFranchisee } from "../../../Helpers/apiCalls/franchiseeApi";
import { getCashCount, getCashCountReport, searchCashCount } from "../../../Helpers/apiCalls/Reports/DailyCashCountApi";
import Footer from "../../../Components/Footer/Footer";


export default function ViewDailyCashCount() {
    const { id, shop } = useParams();
    const { state } = useLocation();
    let navigate = useNavigate();
    var dateToday = getTodayDate();
    const accountType = getType();
    const [inactive, setInactive] = useState(true);
    const [filterConfig, setFilterConfig] = useState({
        cash_count_id: id
    })
    const [cashCounts, setCashCounts] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [sales, setSales] = useState([]);
    const [deposit, setDeposit] = useState([]);
    const [changeFunds, setChangeFunds] = useState([]);
    const [dailySales, setDailySales] = useState([]);
    

    function renderDepositTable() {
        return (
            <Table className="align-middle">
                <thead>
                    <tr>
                        <th>Denomination</th>
                        <th>Quantity</th>
                        <th>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td> PHP 1,000 </td>
                        <td> {cashCounts?.bill_1000} </td>
                        <td> {numberFormat(parseFloat(cashCounts?.bill_1000) * 1000)} </td>
                    </tr>
                    <tr>
                        <td> PHP 500 </td>
                        <td> {cashCounts?.bill_500} </td>
                        <td> {numberFormat(parseFloat(cashCounts?.bill_500) * 500)} </td>
                    </tr>
                    <tr>
                        <td> PHP 200 </td>
                        <td> {cashCounts?.bill_200} </td>
                        <td> {numberFormat(parseFloat(cashCounts?.bill_200) * 200)} </td>
                    </tr>
                    <tr>
                        <td> PHP 100 </td>
                        <td> {cashCounts?.bill_100} </td>
                        <td> {numberFormat(parseFloat(cashCounts?.bill_100) * 100)} </td>
                    </tr>
                    <tr>
                        <td> PHP 50 </td>
                        <td> {cashCounts?.bill_50} </td>
                        <td> {numberFormat(parseFloat(cashCounts?.bill_50) * 50)} </td>
                    </tr>
                    <tr>
                        <td> PHP 20 </td>
                        <td> {cashCounts?.bill_20} </td>
                        <td> {numberFormat(parseFloat(cashCounts?.bill_20) * 20)} </td>
                    </tr>
                    <tr>
                        <td> PHP 10 </td>
                        <td> {cashCounts?.coin_10} </td>
                        <td> {numberFormat(parseFloat(cashCounts?.coin_10) * 10)} </td>
                    </tr>
                    <tr>
                        <td> PHP 5  </td>
                        <td> {cashCounts?.coin_5} </td>
                        <td> {numberFormat(parseFloat(cashCounts?.coin_5) * 5)} </td>
                    </tr>
                    <tr>
                        <td> PHP 1  </td>
                        <td> {cashCounts?.coin_1} </td>
                        <td> {numberFormat(parseFloat(cashCounts?.coin_1) * 1)} </td>
                    </tr>
                    <tr>
                        <td> PHP 25 Cent </td>
                        <td> {cashCounts?.cent_25} </td>
                        <td> {numberFormat(parseFloat(cashCounts?.cent_25) * 25)} </td>
                    </tr>
                </tbody>
            </Table>
        );
    }
    function renderChangeFundsTable() {
        return (
            <Table className="align-middle">
                <thead>
                    <tr>
                        <th>Demomination</th>
                        <th>Quantity</th>
                        <th>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td> PHP 1,000 </td>
                        <td> {cashCounts?.drawer_bill_1000} </td>
                        <td> {numberFormat((parseFloat(cashCounts?.drawer_bill_1000) * 1000))} </td>
                    </tr>
                    <tr>
                        <td> PHP 500 </td>
                        <td> {cashCounts?.drawer_bill_500} </td>
                        <td> {numberFormat((parseFloat(cashCounts?.drawer_bill_500) * 500))} </td>
                    </tr>
                    <tr>
                        <td> PHP 200 </td>
                        <td> {cashCounts?.drawer_bill_200} </td>
                        <td> {numberFormat((parseFloat(cashCounts?.drawer_bill_200) * 200))} </td>
                    </tr>
                    <tr>
                        <td> PHP 100 </td>
                        <td> {cashCounts?.drawer_bill_100} </td>
                        <td> {numberFormat((parseFloat(cashCounts?.drawer_bill_100) * 100))} </td>
                    </tr>
                    <tr>
                        <td> PHP 50 </td>
                        <td> {cashCounts?.drawer_bill_50} </td>
                        <td> {numberFormat((parseFloat(cashCounts?.drawer_bill_50) * 50))} </td>
                    </tr>
                    <tr>
                        <td> PHP 20 </td>
                        <td> {cashCounts?.drawer_bill_20} </td>
                        <td> {numberFormat((parseFloat(cashCounts?.drawer_bill_20) * 20))} </td>
                    </tr>
                    <tr>
                        <td> PHP 10  </td>
                        <td> {cashCounts?.drawer_coin_10} </td>
                        <td> {numberFormat((parseFloat(cashCounts?.drawer_coin_10) * 10))} </td>
                    </tr>
                    <tr>
                        <td> PHP 5  </td>
                        <td> {cashCounts?.drawer_coin_5} </td>
                        <td> {numberFormat((parseFloat(cashCounts?.drawer_coin_5) * 5))} </td>
                    </tr>
                    <tr>
                        <td> PHP 1  </td>
                        <td> {cashCounts?.drawer_coin_1} </td>
                        <td> {numberFormat((parseFloat(cashCounts?.drawer_coin_1) * 1))} </td>
                    </tr>
                    <tr>
                        <td> PHP 25 Cent </td>
                        <td> {cashCounts?.drawer_cent_25} </td>
                        <td> {numberFormat((parseFloat(cashCounts?.drawer_cent_25) * 25))} </td>
                    </tr>
                </tbody>
            </Table>
        );
    }

    function Print() {
        let printContents = document.getElementById("printablediv").innerHTML;
        let originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print(printContents);
        document.body.innerHTML = originalContents;
        refreshPage();
    }

    async function handlePrint() {
        toast.loading("Printing sales invoice...", { style: toastStyle() });
        setTimeout(() => {
            toast.dismiss();
            Print();
        }, 1000);
    }

    async function fetchData() {
        setShowLoader(true);
        setCashCounts([])

        const response = await searchCashCount({id: id});
        
        if (response.data) {
            var allBills = response.data.cash_counts.map((bill) => {
                
                var info = bill;
                info.count_date = dateFormat(bill.count_date)
                info.amount = numberFormat(bill.physical_count);
                info.change_funds = bill.change_funds ? numberFormat(bill.change_funds) : "";
                info.system_cash_amount = bill.system_cash_amount ? numberFormat(bill.system_cash_amount) : "0.00";
                info.cash_variance = bill.cash_variance ? numberFormat(bill.cash_variance) : "0.00";
                return info;
            });
            setCashCounts(allBills[0])
        }
        setShowLoader(false); 
    }
    console.log(cashCounts)

    // async function fetchReport() {
    //     setShowLoader(true);
    //     setSales([])
    //     setDailySales([])

    //     const response = await getCashCountReport(id, state?.date);
        
    //     if (response.data) {
    //         //  gi set nako ang response.data.data as cashcounts then mao ni ako e map ug
    //         //  e update ra nako ang data sa table based sa deposit, changefunds, ug dailysales
    //         // ana na cash count. buhaton ko ni ug ma return na ug tarong sa backend
    //         setCashCounts(response.data) 
    //         var deposit = response.data.deposit[0]
    //         var changefunds = response.data.change_funds[0]
    //         var dailysales = response.data.daily_sales[0]
    //         setDeposit(deposit)
    //         setChangeFunds(changefunds)
    //         setDailySales(dailysales)
    //     }
    //     setShowLoader(false);
    // }
    

    useEffect(() => {
        fetchData();
        // fetchReport();
    }, []);


    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"DS REPORTS"}
                />
            </div>
            <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
                <div className="print-container px-3 py-2" id="printablediv">
                    <div className="d-flex justify-content-center py-1">
                        <img src={cleanLogo} className="print-logo" />
                    </div>
                    <div className="d-flex justify-content-center py-1 ">
                        <h5 className="print-header">
                            DAILY CASH COUNT
                        </h5>
                    </div>

                    {/* content */}
                    <div className="print-body mt-5 justify-content-start">
                        <Row className="d-flex align-items-start">
                            <Col>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Branch:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {cashCounts?.branch_name ? cashCounts.branch_name : ""}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Prepared By:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {cashCounts?.preparer_name ? cashCounts.preparer_name : ""}
                                    </Col>
                                </div>
                            </Col>
                            <Col>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Date:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {formatDateNoTime(cashCounts?.date)}
                                    </Col>
                                </div>
                            </Col>
                        </Row>
                        <div className="d-flex mt-1 justify-content-left">
                            <Col xs={6}>
                                <span className="edit-label">
                                    CASH DEPOSIT
                                </span>
                            </Col>
                            <Col xs={6}>
                                <span className="edit-label">
                                    CHANGE FUNDS
                                </span>
                            </Col>
                        </div>
                        <div className="d-flex mt-2 mb-2 justify-content-evenly">
                            {/* table */}
                            <div className="print-table mt-3 mx-2">
                                {renderDepositTable()}
                            </div>
                            <div className="print-table mt-3 mx-2">
                                {renderChangeFundsTable()}
                            </div>
                        </div>
                        <div className="d-flex mx-2 mt-2 mb-2 justify-content-evenly">
                            <Col xs={6}>
                                <Row className="text-end">
                                    <div className="d-flex my-2 justify-content-end ">
                                        <Col className="print-data">
                                            Total Cash Deposit: {cashCounts.total_cash_deposit ? numberFormat(cashCounts.total_cash_deposit) : "0.00" }
                                        </Col>
                                    </div>
                                </Row>
                            </Col>
                            <Col xs={6}>
                                <Row className="text-end">
                                    <div className="d-flex my-2 justify-content-end ">
                                        <Col className="print-data">
                                            Total Change Funds: {cashCounts.total_cash_drawer ? numberFormat(cashCounts.total_cash_drawer) : "0.00" }
                                        </Col>
                                    </div>
                                </Row>
                                <Row className="text-end">
                                    <div className="d-flex my-2 justify-content-end ">
                                        <Col className="print-data">
                                            Initial Cash in Drawer: {cashCounts ? numberFormat(cashCounts.initial_drawer) : "0.00" }
                                        </Col>
                                    </div>
                                </Row>
                            </Col>
                        </div>
                        <Row>
                            <h5 className="d-flex green justify-content-center">
                                ACTUAL AND SYSTEM CASH SALES COMPARISON
                            </h5>
                        </Row>
                        <div className="d-flex review-container">
                            <Col xs={5}>
                                <Row className=" d-flex mb-1 justify-content-center p-3 mx-2">
                                    <Row className=" justify-content-center">
                                        <Row className="text-center">
                                            <span className="cash-breakdown-subheader justify-content-center green">
                                                ACTUAL TOTAL CASH
                                            </span>
                                        </Row>
                                        <Col xs={12} className='p-2 m-1'>
                                            {/* <Row>
                                                <Col className="text-end" xs={6}><span className="print-data justify-content-center green">Remitted Amount</span></Col>
                                                <Col className="text-end" xs={6}><span className="print-data justify-content-center green">System</span></Col>
                                            </Row> */}
                                            <Row className="mt-1">
                                                <Col className="text-start " xs={8}><span className="print-data text-start">Deposited Cash Sales</span></Col>
                                                <Col className="text-end " xs={4}><span className="print-data text-end ">{dailySales ? numberFormat(dailySales.actual_cash_sales) : ''}</span></Col>
                                            </Row>
                                            <Row className="mt-1">
                                                <Col className="text-start " xs={6}><span className="print-data text-start">Total Expense</span></Col>
                                                <Col className="text-end " xs={6}><span className="print-data text-end ">+{dailySales ? numberFormat(dailySales.total_expense) : '0.00'}</span></Col>
                                            </Row>
                                            <hr/>
                                            <Row className="mt-1">
                                                <Col xs={6}><h5 className="print-data"></h5></Col>
                                                <Col className="text-end" xs={6}><span className="print-data text-end green">{dailySales ? numberFormat(parseFloat(dailySales.actual_cash_sales) + parseFloat(dailySales.total_expense)) : ''}</span></Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Row>
                            </Col>
                            <Col xs={2}>
                                <div className="vl mt-5"></div>
                            </Col>
                            <Col xs={5}>
                                <Row className="review-container d-flex mb-1 justify-content-center p-3 mx-2">
                                    <Row className=" justify-content-center">
                                        <Row className="text-center">
                                            <span className="cash-breakdown-subheader justify-content-center green">
                                                SYSTEM TOTAL CASH
                                            </span>
                                        </Row>
                                        <Col xs={12} className='p-2 m-1'>
                                            <Row className="mt-1">
                                                <Col className="text-start " xs={8}><span className="print-data text-start">System Cash Sales</span></Col>
                                                <Col className="text-end " xs={4}><span className="print-data text-end ">{dailySales ? numberFormat(dailySales.system_cash_sales) : ''}</span></Col>
                                            </Row>
                                            <Row className="mt-1">
                                                <Col className="text-start " xs={6}><span className="print-data text-start">Total Expense</span></Col>
                                                <Col className="text-end " xs={6}><span className="print-data text-end ">-{dailySales ? numberFormat(dailySales.total_expense) : '0.00'}</span></Col>
                                            </Row>
                                            <hr/>
                                            <Row className="mt-1">
                                                <Col xs={6}><h5 className="print-data"></h5></Col>
                                                <Col className="text-end" xs={6}><span className="print-data text-end green">{dailySales ? numberFormat(parseFloat(dailySales.system_cash_sales) - parseFloat(dailySales.total_expense)) : ''}</span></Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Row>
                            </Col>
                        </div>
                        {/* <Row>
                            <h5 className="d-flex green justify-content-center">
                                NET ACTUAL AND SYSTEM CASH SALES COMPARISON
                            </h5>
                        </Row>
                        <div className="d-flex review-container">
                            <Col xs={5}>
                                <Row className=" d-flex mb-1 justify-content-center p-3 mx-2">
                                    <Row className=" justify-content-center">
                                        <Row className="text-center">
                                            <span className="cash-breakdown-subheader justify-content-center green">
                                                NET ACTUAL TOTAL CASH
                                            </span>
                                        </Row>
                                        <Col xs={12} className='p-2 m-1'>
                                            <Row className="mt-1">
                                                <Col className="text-start " xs={8}><span className="print-data text-start">Remitted Cash Sales</span></Col>
                                                <Col className="text-end " xs={4}><span className="print-data text-end ">{dailySales ? numberFormat(dailySales.actual_cash_sales) : ''}</span></Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Row>
                            </Col>
                            <Col xs={2}>
                                        <div className="vl mt-5"></div>
                                    </Col>
                            <Col xs={5}>
                            <Row className="review-container d-flex mb-1 justify-content-center p-3 mx-2">
                                <Row className=" justify-content-center">
                                        <Row className="text-center">
                                            <span className="cash-breakdown-subheader justify-content-center green">
                                                NET SYSTEM TOTAL CASH
                                            </span>
                                        </Row>
                                        <Col xs={12} className='p-2 m-1'>
                                            <Row className="mt-1">
                                                <Col className="text-start " xs={8}><span className="print-data text-start">System Cash Sales</span></Col>
                                                <Col className="text-end " xs={4}><span className="print-data text-end ">{dailySales ? numberFormat(dailySales.net_system_sales) : ''}</span></Col>
                                            </Row>
                                            <Row className="mt-1">
                                                <Col className="text-start " xs={6}><span className="print-data text-start">Total Expense</span></Col>
                                                <Col className="text-end " xs={6}><span className="print-data text-end ">-{dailySales ? numberFormat(dailySales.total_expense) : '0.00'}</span></Col>
                                            </Row>
                                            <hr/>
                                            <Row className="mt-1">
                                                <Col xs={6}><h5 className="print-data"></h5></Col>
                                                <Col className="text-end" xs={6}><span className="print-data text-end green">{dailySales ? numberFormat(parseFloat(dailySales.net_system_sales) - parseFloat(dailySales.total_expense)) : ''}</span></Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Row>
                            </Col>
                        </div> */}
                        <div>
                            <Row className="review-container py-3 me-2 ms-2 mt-3">
                                <Row className="text-center">
                                    <span className="cash-breakdown-subheader justify-content-center green">
                                        CASH DEPOSIT SUMMARY
                                    </span>
                                </Row>
                                <Row>
                                    <Col xs={8}  className="print-data mt-2 mb-1">
                                        <Row className="justify-content-left ms-5 mt-1 mb-1">
                                            Actual Cash Deposit Total
                                        </Row>
                                        <Row className="justify-content-left ms-5 mt-1 mb-1">
                                            System Cash Deposit Total
                                        </Row>
                                    </Col>
                                    <Col xs={4}  className="print-data pl-2 mt-2 mb-1">
                                        <Row className="justify-content-end me-5">
                                            {cashCounts.physical_count ? numberFormat(cashCounts.physical_count) : "0.00" }
                                            {/* {dailySales ? numberFormat(dailySales.actual_cash_sales) : "" } */}
                                        </Row>
                                        <Row className="justify-content-end mt-1 me-5">
                                            {numberFormat(parseFloat(cashCounts.system_cash_sales) - parseFloat(cashCounts.total_system_expense))}
                                            {/* {dailySales ? numberFormat(dailySales.system_cash_sales) : "" } */}
                                        </Row>
                                    </Col>
                                </Row>
                                <div className="break "> </div>
                                <Row>
                                    <Col xs={8}  className="print-data mt-2 mb-1">
                                        <Row className="justify-content-left ms-5">
                                            OVERAGE/SHORTAGE
                                        </Row>
                                    </Col>
                                    <Col xs={4}  className="print-data mt-2 mb-1">
                                        <Row className="justify-content-end me-5">
                                            {cashCounts ? numberFormat(cashCounts.cash_sales_overage) : "" }
                                        </Row>
                                    </Col>
                                </Row>
                            </Row>
                        </div>
                        <div>
                            <Row className="review-container py-3 me-2 ms-2 mt-3">
                                <Row className="text-center">
                                    <span className="cash-breakdown-subheader justify-content-center green">
                                        TOTAL SALES SUMMARY
                                    </span>
                                </Row>
                                <Row>
                                    <Col xs={5}></Col>
                                    <Col xs={3} className="print-data mt-2 mb-1">
                                        <Row className="justify-content-center mt-1 mb-1">
                                            Actual Cash Sales   
                                        </Row>
                                        <Row className="justify-content-center mt-1 mb-1">
                                            {cashCounts ? numberFormat(cashCounts.actual_cash_sales) : "" }
                                        </Row>
                                    </Col>
                                    <Col xs={1}>
                                        <div className="vl"></div>
                                    </Col>
                                    <Col xs={3} className="print-data mt-2 mb-1">
                                        <Row className="justify-content-center mt-1 mb-1">
                                            System Cash Sales   
                                        </Row>
                                        <Row className="justify-content-center mt-1 mb-1">
                                            {cashCounts ? numberFormat(parseFloat(cashCounts.system_cash_sales) - parseFloat(cashCounts.total_expense)) : ''}
                                            {/* {dailySales ? numberFormat(dailySales.system_cash_sales) : "" } */}
                                        </Row>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={3}  className="print-data mt-2 mb-1">
                                        <Row className="justify-content-right ms-5 mt-1 mb-1">
                                            Check Sales
                                        </Row>
                                        <Row className="justify-content-right ms-5 mt-1 mb-1">
                                            Bank Sales
                                        </Row>
                                        <Row className="justify-content-right ms-5 mt-1 mb-1">
                                            Other Sales
                                        </Row>
                                    </Col>
                                    <Col xs={4}></Col>
                                    <Col xs={3}  className="print-data mt-2 mb-1">
                                        <Row className="justify-content-center mt-1 mb-1">
                                            {cashCounts ? numberFormat(cashCounts.check_sales) : "" }
                                        </Row>
                                        <Row className="justify-content-center mt-1 mb-1">
                                            {cashCounts ? numberFormat(cashCounts.bank_sales) : "" }
                                        </Row>
                                        <Row className="justify-content-center mt-1 mb-1">
                                            {cashCounts ? numberFormat(cashCounts.other_sales) : "" }
                                        </Row>
                                    </Col>
                                </Row>
                                <div className="break "> </div>
                                <Row>
                                    <Col xs={5}  className="print-data mt-2 mb-1">
                                        <Row className="justify-content-right ms-5 green">
                                            TOTAL SALES
                                        </Row>
                                    </Col>
                                    <Col xs={3}  className="print-data mt-2 mb-1">
                                        <Row className="justify-content-center green">
                                            {cashCounts ? numberFormat(cashCounts.actual_total_sales) : "0.00"}
                                        </Row>
                                    </Col>
                                    <Col xs={1}></Col>
                                    <Col xs={3}  className="print-data mt-2 mb-1">
                                        <Row className="justify-content-center green">
                                            {cashCounts ? numberFormat(parseFloat(cashCounts.system_total_sales) - parseFloat(cashCounts.total_expense)) : "0.00"}
                                            {/* {dailySales ? numberFormat(dailySales.system_total_sales): "0.00"} */}
                                        </Row>
                                    </Col>
                                </Row>
                            </Row>
                        </div>
                        <div className="print-signatures mt-5">
                            <div className="d-flex align-items-center justify-content-end flex-column">
                                <span className="text-center text-uppercase print-label fw-bold">
                                    {cashCounts ? cashCounts.prepared_by_name : ""}
                                </span>
                            </div>
                            <div className="d-flex align-items-center justify-content-center flex-column">
                                {/* <img src={signature} className="print-logo" /> */}
                                <span className="text-center text-uppercase print-label fw-bold">
                                    {cashCounts ? cashCounts.approved_by_name : ""}
                                </span>
                            </div>
                        </div>
                        <div className="print-signatories pb-2">
                            <span>Prepared by</span>
                            <span>Approved by</span>
                        </div>
                    </div>
                </div>

                {/* footer */}
                <div className="d-flex justify-content-end my-4 pb-5 d-flex-responsive">
                    <button
                        className="button-secondary me-3"
                        onClick={() => navigate(-1)}
                    >
                        Close
                    </button>
                    <button
                        className="button-primary me-3"
                        onClick={handlePrint}
                    >
                        Print
                    </button>
                </div>
            </div>
            <Footer/>
        </div>
    );
}
